import Footer from "../../components/common/Footer/Footer";
import Header from "../../components/common/Header/Header";
import classes from "../../styles/Home.module.scss";
import classnames from "classnames";
import { nanoid } from "nanoid";
import ContactUs from "../../components/common/ContactUs/ContactUs";
import Banner from "../../components/common/Banner/Banner";
import BannerType from "../../global/banner-type";
import {
  ourChannels,
  ourSolution,
  caseStudy,
  comments,
  brands,
  platforms,
  experience,
  features,
} from "../../global/constant";
import CommentSection from "../../components/common/CommentSection/CommentSection";
import CustomImage from "../../components/core/CustomImage/CustomImage";
import banner_one from "../../assets/images/banner_one.png";
import useIsMobile from "../../components/hooks/useIsMobile";
import { useNavigate } from "react-router";
import { APP_PATH } from "../../routes/route";
import OurClientBase from "./components/OurClientBase";
import Introduction from "./components/Introduction";
import OurProducts from "./components/OurProducts";
import CaseStudies from "./components/CaseStudies";
/* import tickIcon from '../../assets/icons/tick_blackcircle.svg';
import CustomIcon from "../../components/core/CustomIcon/CustomIcon";
import featurelist from "../../assets/images/featurelist.png"; */

const Home = () => {
  const isMobile = useIsMobile({ breakpoint: 768 });
  const navigate = useNavigate();
  return (
    <>
      <Header />
      <div className={classnames(classes.container, "minheightCont100vh")}>
        <Introduction />
        <div className={classnames("containerWidth")}>
          <OurProducts platforms={platforms} />
          {/* <div>
            <div className={classnames(classes.heading, "heading")}>
              Rich Feature list
            </div>
            <div className={classnames("subheading")}>
              Paytm is a one-stop-shop for all of your marketing needs. Whether
              you’re looking to launch new campaigns, manage your call centre,
              set up a loyalty program, or even implement on HRMS system, Paytm
              has the tools and resources you need to succeed. So why wait? Sign
              up today and start taking your busiiness to the next level.
            </div>
            <div className={classnames(classes.richFeatureList)}>
              <CustomImage
                src={featurelist}
                style={{ maxWidth: isMobile ? "unset" : 400 }}
                width="100%"
              />
              <ul className={classnames(classes.list)}>
                {features.map(feature => {
                  return (
                    <li key={nanoid()}>
                      <CustomIcon
                        src={tickIcon}
                        iconHeight={16}
                        iconWidth={16}
                      />
                      <div className={classnames(classes.feature)}>
                        {feature}
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div> */}
          <div className={classnames(classes.backgroundImage)}>
            <div
              className={classnames(classes.heading, "heading")}
              style={{
                marginBottom: "40px",
                fontSize: isMobile ? "3rem" : "5rem",
              }}
            >
              Experience
            </div>
            <div className={classnames("subheading")}>
              Paytm is one of the most reliable and trustworthy payment service
              providers in India. Our commitment to providing the latest and
              best futuristic payment solution has made them a favourite among
              customers. Don’t just take our word for it, though. The client
              testimonials for Paytm services speak volumes about their
              excellence. From small business owners to large corporations,
              Paytm has earned the trust and loyalty of countless satisfied
              customers.
            </div>
            <div
              className={classnames(classes.flex_box, classes.experience_flex)}
              style={{ gap: 0, justifyContent: "center" }}
            >
              {experience.map(data => {
                return (
                  <div className={classnames(classes.block)} key={nanoid()}>
                    <div
                      className={classnames("heading", classes.experienceData)}
                      style={{
                        whiteSpace: "nowrap",
                        margin: 0,
                      }}
                    >
                      {data.value}
                    </div>
                    <div className={classnames("subheading")}>{data.type}</div>
                  </div>
                );
              })}
            </div>
          </div>
          <OurClientBase brands={brands} />
          <div>
            <div
              className={classnames(
                classes.heading,
                classes.WhatOurClientsSay,
                "heading"
              )}
              style={{ paddingTop: 0 }}
            >
              What Our Clients Say
            </div>
            {/* <div className={classnames("subheading")}>
              It takes dark in order to show light. Just use the old one inch
              brush. It just happens - whether or not you worried about it or
              tried to plan it. Let's put a touch more of the magic here.
            </div> */}
            {/* <CommentSection slides={comments} key={nanoid()} /> */}
          </div>
          <CaseStudies caseStudy={caseStudy} />
          <div>
            <div className={classnames(classes.heading, "heading")}>
              Our Solutions
            </div>
            <div className={classnames("subheading")}>
              Align our result-driven Enterprise Solutions with your marketing
              objectives.
            </div>
            <div className={classnames(classes.flex_box)}>
              {ourSolution.map(solution => {
                if (solution.id === "contactus") {
                  return null; // Skip rendering the Banner for 'contactus' channel
                }
                return (
                  <Banner
                    type={BannerType.SERVICE_BANNER}
                    {...solution}
                    key={nanoid()}
                    className={classes.alignCenter}
                    clickHandler={() =>
                      navigate(`${APP_PATH}/oursolutions/${solution.id}`)
                    }
                  />
                );
              })}
            </div>
          </div>
          <div>
            <div className={classnames(classes.heading, "heading")}>
              Our Channels
            </div>
            <div className={classnames("subheading")}>
              Be omnipresent in your customer’s mind with our channel coverage
            </div>
            <div className={classnames(classes.flex_box)}>
              {ourChannels.map(channel => {
                if (channel.id === "contactus") {
                  return null; // Skip rendering the Banner for 'contactus' channel
                }
                return (
                  <Banner
                    type={BannerType.CHANNEL_BANNER}
                    {...channel}
                    key={nanoid()}
                    className={classes.alignCenter}
                    clickHandler={() =>
                      navigate(`${APP_PATH}/channels/${channel.id}`)
                    }
                  />
                );
              })}
            </div>
          </div>
        </div>
        <ContactUs />
        <Footer />
      </div>
    </>
  );
};
export default Home;
